import { FiBookOpen } from 'react-icons/fi';
import type { DropdownIndicatorProps, FormatOptionLabelMeta } from 'react-select';
import { components } from 'react-select';

import { Option } from 'types';

/**
 * Customer / Shipping / Goods selects sit in the narrow code column: the menu
 * keeps the full `code - name - address` labels, the selected value shows only
 * the code (the name is shown in the box next to it).
 */
export const formatCodeOptionLabel = (
  option: Option,
  { context }: FormatOptionLabelMeta<Option>
) => (context === 'value' && option.value !== '' ? String(option.value) : option.label);

/** Code-column select menu: input width, grows for longer labels up to this width. */
export const CODE_SELECT_MENU_MAX_WIDTH = 'min(60rem, 90vw)';

function AddressBookIndicator(props: DropdownIndicatorProps<Option, boolean>) {
  return (
    <components.DropdownIndicator {...props}>
      <FiBookOpen size="1.8rem" />
    </components.DropdownIndicator>
  );
}

const addressBookSelectComponents = { DropdownIndicator: AddressBookIndicator };
const noIndicatorSelectComponents = { DropdownIndicator: () => null };

/**
 * Code-column selects as in the mockup: the open-book icon (instead of the chevron) while the
 * block is expanded, no icon while it is collapsed.
 */
export const codeSelectComponents = (isOpen: boolean) =>
  isOpen ? addressBookSelectComponents : noIndicatorSelectComponents;
